<template>
  <div class="cm-discuss-item-images">
    <a
      data-fancybox="gallery"
      :href="util.getImageUrl(image, '1000-')"
      v-for="(image, index) in util.string2Array(images)"
      :key="index"
    >
      <img :src="util.getImageUrl(image, '120x120')" />
    </a>
  </div>
</template>

<script>
export default {
  name: "CommodityMarketingDiscussItemImages",
  props: {
    images: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.cm-discuss-item-images {
  width: 100%;
  img {
    width: 75px;
    height: 75px;
    border-radius: 5px;

    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>
